import React, { Component } from "react";
import Link from "gatsby-link";
import {
  Form,
  Segment,
  Divider,
  Grid,
  Button,
  Input,
  Dropdown
} from "semantic-ui-react";
import {
  bedroomOptions,
  bathroomOptions,
  timeOptions,
  stateList
} from "./consts/contactConsts";
import FreqButton from "./FormButton";
import FreqButtonGroup from "./FreqButtonGroup";
import { Field, reduxForm } from "redux-form";
import { graphql, gql } from "react-apollo";
import FormField from "../../semanticFormField";
import DropdownField from "../../semanticDropdown";
import DayPicker from "./dayPicker";

class ContactForm extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount = () => {
    const { frequency, numBedrooms, numBathrooms } = this.props;
  };
  onSubmit = values => {
    console.log(values);
  };
  render() {
    const {
      handleSubmit,
      frequency,
      numBedrooms,
      numBathrooms,
      updateFrequency,
      updateBedrooms,
      updateBathrooms,
      updateDate,
      updateTime
    } = this.props;
    return (
      <Segment padded>
        <div style={{ textAlign: "center", margin: "0 auto" }}>
          <h2>Complete your booking.</h2>
          <h3>
            Great! Give us a few details and we can complete your booking.
          </h3>

          {!this.props.loggedIn && (
            <p>
              Already a customer?<br />
              <br />
              <Link to="/login">
                <Button basic color="green" size="mini">
                  Log in!
                </Button>
              </Link>
            </p>
          )}
        </div>
        <Divider />
        <div style={{ textAlign: "left" }}>
          <Form onSubmit={handleSubmit(this.onSubmit)} onChange={e => {}}>
            <h3>Step 1: Who you are</h3>
            <p>
              This information will be used to contact you about your service.
            </p>
            <Form.Group widths="equal">
              <Field
                component={FormField}
                label="First name"
                placeholder="First name"
                name="firstName"
                type="text"
              />
              <Field
                component={FormField}
                label="Last name"
                name="lastName"
                placeholder="Last name"
                type="input"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Field
                component={FormField}
                label="Email"
                placeholder="Email"
                name="email"
              />
              <Field
                component={FormField}
                label="Phone"
                placeholder="Phone"
                name="phone"
              />
            </Form.Group>
            {!this.props.loggedIn && (
              <Form.Group widths="equal">
                <Field
                  component={FormField}
                  label="Password"
                  placeholder="Password"
                  name="password"
                  type="password"
                />
                <Field
                  component={FormField}
                  label="Confirm Password"
                  placeholder="Password"
                  name="confirmPassword"
                  type="password"
                />
              </Form.Group>
            )}

            <Divider />
            <h3>Step 2: Your home</h3>
            <p>Where would you like us to clean? </p>
            <Form.Group>
              <Field
                width="16"
                component={FormField}
                label="Address"
                placeholder="Address"
                name="address"
              />
              {/* <Field
                component={FormField}
                width="4"
                label="Apt/Suite #"
                placeholder="Apt/Suite #"
                name="aptNumber"
              /> */}
            </Form.Group>
            <Form.Group>
              <Field
                component={FormField}
                width="12"
                label="City"
                placeholder="City"
                name="city"
              />
              {/* <Field
                component={DropdownField}
                placeholder="FL"
                selection
                options={stateList}
                label="State"
                name="state"
              /> */}
              <Field
                fluid
                component={FormField}
                type="number"
                width="4"
                label="Zip Code"
                placeholder="Zip Code"
                name="zip"
              />
            </Form.Group>
            <Divider />
            <h3>Step 3: Choose your service</h3>
            <p>
              Tell us about your home. (The kitchen, living room, and other
              common areas are always included.)
            </p>
            <Form.Group widths="equal">
              <Field
                component={DropdownField}
                placeholder="1 Bedroom"
                selection
                options={bedroomOptions}
                label="Bedrooms"
                name="numBedrooms"
              />
              <Field
                component={DropdownField}
                placeholder="1 Bathroom"
                selection
                options={bathroomOptions}
                label="Bathrooms"
                name="numBathrooms"
              />
            </Form.Group>
            <Divider />
            <h3>Select Extras</h3>
            <p>//TODO: Add Extras</p>
            <Divider />

            <h3>When would you like us to come?</h3>
            <Grid columns={2} doubling>
              <Grid.Column>
                {/* <DayPicker
                  value={formattedDay}
                  placeholder={moment().format(DAY_FORMAT)}
                  onDayChange={this.handleDayChange}
                  format={DAY_FORMAT}
                  dayPickerProps={dayPickerProps}
                /> */}
                <Field component={DayPicker} name="selectedDate" />
              </Grid.Column>
              <Grid.Column>
                <Field
                  component={DropdownField}
                  placeholder="Select Time"
                  fluid
                  selection
                  options={timeOptions}
                  name="selectedTime"
                />
              </Grid.Column>
            </Grid>
            <Divider />
            <h3>How Often?</h3>
            <p>
              It's all about matching you with the perfect clean for your home.
              Scheduling is flexible. Cancel or reschedule anytime.{" "}
            </p>
            <Field component={FreqButtonGroup} name="frequency" />
            {/* <Divider />
            <h3>Step 5: Select Payment Method</h3>
            <p>
              Enter your card information below. You will be charged after
              service has been rendered.
            </p>
            // TODO: Add payment integration here
            <Divider />
            <p>
              By clicking the Book Now button you are agreeing to our Terms of
              Service and Privacy Policy.
            </p>
            <Button size="huge" fluid color="green">
              Book Now
            </Button> */}
            {/* <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Elements>
                    <StripeTest />
                  </Elements>
                </Grid.Column>
              </Grid.Row>
            </Grid> */}
          </Form>
        </div>
      </Segment>
    );
  }
}
const myMutation = gql`
  mutation CreateUser(
    $address: String!
    $city: String!
    $firstName: String!
    $lastName: String!
    $phone: String!
    $zip: String!
    $jobAddress: String!
    $jobCity: String!
    $price: Float!
    $time: DateTime!
    $jobZip: String!
    $cardToken: String!
    $email: String!
    $password: String!
  ) {
    createUser(
      address: $address
      city: $city
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      zip: $zip
      jobs: {
        address: $jobAddress
        city: $jobCity
        price: $price
        time: $time
        zip: $jobZip
        cardDetails: { cardToken: $cardToken }
      }
      authProvider: { email: { email: $email, password: $password } }
    ) {
      __typename
    }
  }
`;

ContactForm = reduxForm({
  // a unique name for the form
  form: "contact",
  enableReinitialize: true
})(ContactForm);

export default graphql(myMutation)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/ReduxFormComponent.jsx